import { Children, forwardRef, Fragment } from 'react';
import { PiCaretRight } from 'react-icons/pi';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type BreadcrumbElement = FlexElement;
export interface BreadcrumbProps extends FlexProps {
  children?: React.ReactNode;
}

export const Breadcrumb = forwardRef<BreadcrumbElement, BreadcrumbProps>(
  ({ children, ...restProps }, ref) => {
    return (
      <Flex
        ref={ref}
        alignItems="center"
        gap="var(--spacing-gap)"
        justifyContent="flex-start"
        {...restProps}
      >
        {Children.toArray(children).map((child, index) => (
          <Fragment key={index}>
            {index !== 0 && <PiCaretRight />}
            {child}
          </Fragment>
        ))}
      </Flex>
    );
  }
);
